export const formatSheetVersionDate = (date: Date) =>
  date.toISOString().slice(0, 10).replace(/-/g, "");
